import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { showSnackbar } from '../../../api/snackbarSlice';
import { useDispatch } from 'react-redux';
import { apiClient } from '../../../utils/axios';
import { AxiosError } from 'axios';

const fetchBusinessProfiles = async ({ queryKey }) => {
  const [, params] = queryKey;
  const { data } = await apiClient.get(`/business-profiles`, { params });
  return data;
};

export const useGetBusinessProfilesHandler = ({ searchQuery, enabled = true }) => {
  const dispatch = useDispatch();
  const [businessProfiles, setBusinessProfiles] = useState([]);
  const [totalDocuments, setTotalDocuments] = useState(0);
  const queryClient = useQueryClient();

  const {
    data: fetchedData,
    isLoading,
    isError,
    error,
  } = useQuery(
    {
      queryKey: ['business_profiles', { ...searchQuery }], // A unique key for this query
      cacheTime: 0,
      queryFn: fetchBusinessProfiles,
      enabled,
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
      refetchOnMount: 'always',
    },
    queryClient,
  );

  useEffect(() => {
    if (fetchedData) {
      setBusinessProfiles(fetchedData.content);
      setTotalDocuments(fetchedData.total_elements);
    }
  }, [fetchedData]);

  useEffect(() => {
    if (isError) {
      if (error instanceof AxiosError) {
        if (error.status) {
          dispatch(showSnackbar({ message: error.response.data.message, severity: 'error' }));
        } else {
          dispatch(showSnackbar({ message: error.message, severity: 'error' }));
        }
      } else {
        dispatch(showSnackbar({ message: JSON.stringify(error), severity: 'error' }));
      }
    }
  }, [dispatch, error, isError]);

  return {
    businessProfiles,
    totalDocuments,
    isLoading,
  };
};
